// "My view" — personalised dashboard with the signed-in user's open work,
// recent activity, and a team presence row. Reuses StoriesSection from shared-gov.

import { pageBoilerplateFetch } from '../functions/tickets/ticketUtils.js'
import { fetchTicketsAssignedTo } from '../functions/tickets/ticketLoaders.js'
import { subscribeTicketsRealtime } from '../functions/tickets/subscribeTicketsRealtime.js'

export const myView = {
  extends: 'AppPage',
  metadata: { title: 'My view / Tickets / Symbols Workspace' },

  onInit: (el, s) => {
    if (el.call('redirectIfExternalOnly', s)) return
  },

  fetch: pageBoilerplateFetch,

  onCreate: async (el, s) => {
    // Wait for currentUserEmail to be populated by app.js auth
    let email = s.root.currentUserEmail
    if (!email) {
      await new Promise(resolve => {
        let attempts = 0
        const check = setInterval(() => {
          email = s.root.currentUserEmail
          if (email || ++attempts > 30) { clearInterval(check); resolve() }
        }, 200)
      })
    }
    if (!email) email = 'nika@symbols.app'
    const rows = await fetchTicketsAssignedTo(email, 100)
    s.root.update({ myTickets: rows })

    // Realtime: refresh myTickets when ASK-USER decisions or awaiting-approval
    // tickets are filed / updated, so Nika sees them without a manual reload.
    el._rtUnsub = subscribeTicketsRealtime({
      pageName: 'my-view',
      tables: ['tickets'],
      onRefresh: async () => {
        const addr = s.root.currentUserEmail || email
        const next = await fetchTicketsAssignedTo(addr, 100)
        if (next.length) s.root.update({ myTickets: next })
      },
      // Optimistic patch: when a ticket assigned to the current user gains the
      // ASK-USER label or awaiting_approval state, splice it into myTickets
      // immediately so the "Awaiting your approval" section lights up in <150ms.
      onOptimisticPatch: (_table, eventType, row) => {
        const addr = s.root.currentUserEmail || email
        if (!addr || row.assignee_email !== addr) return
        const isAskUser =
          row.state === 'awaiting_approval' ||
          (Array.isArray(row.labels) && row.labels.includes('ASK-USER'))
        if (!isAskUser && eventType !== 'UPDATE') return
        const existing = (s.root.myTickets || [])
        const idx = existing.findIndex(t => t.id === row.id)
        if (idx >= 0) {
          // Update in-place
          const updated = [...existing]
          updated[idx] = { ...existing[idx], ...row }
          s.root.update({ myTickets: updated })
        } else if (eventType === 'INSERT' && isAskUser) {
          s.root.update({ myTickets: [row, ...existing] })
        }
      }
    })
  },

  onRemove: (el) => {
    if (el._rtUnsub) { el._rtUnsub(); el._rtUnsub = null }
    const root = el.getRoot()
    if (root && root.selectedTicket) root.update({ selectedTicket: null })
  },

  TicketsSidebar: {},
  TicketsMyViewMain: {},
  TicketsNewTicketModal: {},
  TicketsDetailModal: {},
  TicketMentionModal: {}
}
